import Component from './component';

export interface Props {
    phoneIcon: {
        icon: string;
        phone: string;
        phoneLink: string;
        alt?:string;
    }
}

Component.defaultProps = {};

export default Component;